import { render, staticRenderFns } from "./card-open.vue?vue&type=template&id=5cc7527f&scoped=true&"
import script from "./card-open.vue?vue&type=script&lang=ts&"
export * from "./card-open.vue?vue&type=script&lang=ts&"
import style0 from "./card-open.vue?vue&type=style&index=0&id=5cc7527f&prod&lang=scss&scoped=true&"
import style1 from "./card-open.vue?vue&type=style&index=1&id=5cc7527f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc7527f",
  null
  
)

export default component.exports